export const USER_TABLE = Object.freeze({
  TABLE_NAME: 'user-table',
  USERNAME_FIELD: 'username',
});

export const TEAM_TABLE = Object.freeze({
  TABLE_NAME: 'team-table',
  NAME_FIELD: 'name',
  USER_COUNT_FIELD: 'user_count',
});

export const SELECT_ALL_ASSIGNMENT_TARGET = 'select-all-assignments';

export const MAIN_TAB_DEVICES = 'devices';
export const MAIN_TAB_GROUPS = 'lines-of-business';
export const MAIN_TAB_INVITATIONS = 'invitations';
export const MAIN_TAB_TEAMS = 'teams';
export const MAIN_TAB_USERS = 'users';

export const SETTINGS_TAB_SECURITY = 'security';
export const SETTINGS_TAB_SSO = 'sso';
export const SETTINGS_TAB_ENTITLEMENTS = 'entitlements';
export const SETTINGS_TAB_NAMES = [
  SETTINGS_TAB_SECURITY,
  SETTINGS_TAB_SSO,
  SETTINGS_TAB_ENTITLEMENTS,
];
export const SETTINGS_TAB_DEFAULT_NAME = SETTINGS_TAB_SECURITY;

// SSO settings
export const SSO_PROVIDERS = {
  MAIN: 'Standard SP',
  AUXILIARY: 'Auxiliary SP1',
};

export const SSO_MIGRATION_READY = 'for_migration';
export const SSO_MIGRATION_UNAVAILABLE = 'global_only';

// Modals
export const SSO_MIGRATION_MODAL = 'ssoMigrationModal';
export const TEAMS_ASSIGNMENT_MODAL = 'teamsAssignmentModal';
